import SiteHeader from "@/components/feature/SiteHeader";
import SiteFooter from "@/components/feature/SiteFooter";
import BackToTop from "@/components/feature/BackToTop";
import JsonLd from "@/components/feature/JsonLd";
import Reveal from "@/components/feature/Reveal";
import { useSeo } from "@/hooks/useSeo";
import { topics } from "@/mocks/topics";
import Hero from "@/pages/home/components/Hero";
import FeaturedPick from "@/pages/home/components/FeaturedPick";
import TrendingRank from "@/pages/home/components/TrendingRank";
import TopicGrid from "@/pages/home/components/TopicGrid";
import FeatureShowcase from "@/pages/home/components/FeatureShowcase";
import FaqSection from "@/pages/home/components/FaqSection";
import CtaBand from "@/pages/home/components/CtaBand";

export default function Home() {
  useSeo({
    title: "5看料网 - 热点话题与娱乐资讯聚合，收藏标记随时回看",
    description:
      "5看料网聚合每日网络热点、娱乐动态与话题资讯，提供收藏、保存、书签、记录、标记、关注工具，帮你把感兴趣的内容随手存下，随时回看，不错过任何一条重要动态。",
    keywords: "5看料网,5看料网收藏,5看料网书签,热点话题,娱乐资讯,话题爆料",
    path: "/",
  });

  const itemList = {
    "@context": "https://schema.org",
    "@type": "ItemList",
    name: "5看料网本周热榜",
    itemListElement: topics.slice(0, 6).map((topic, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: topic.title,
    })),
  };

  const websiteLd = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "5看料网",
    url: "https://tpon.cn/",
    description:
      "聚合每日网络热点、娱乐动态与话题资讯，支持收藏、保存、书签、记录、标记与关注。",
    inLanguage: "zh-CN",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://tpon.cn/topics?query={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  };

  const orgLd = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "5看料网",
    url: "https://tpon.cn/",
    description: "关注网络热点与娱乐动态的内容聚合平台。",
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "customer support",
      email: "hello@5kanliao.cn",
    },
  };

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <SiteHeader />
      <main className="flex-1">
        <Hero />
        <Reveal>
          <FeaturedPick />
        </Reveal>
        <Reveal>
          <TrendingRank />
        </Reveal>
        <Reveal>
          <TopicGrid />
        </Reveal>
        <Reveal>
          <FeatureShowcase />
        </Reveal>
        <Reveal>
          <FaqSection />
        </Reveal>
        <Reveal>
          <CtaBand />
        </Reveal>
      </main>
      <SiteFooter />
      <BackToTop />
      <JsonLd id="home-website" data={websiteLd} />
      <JsonLd id="home-org" data={orgLd} />
      <JsonLd id="home-itemlist" data={itemList} />
    </div>
  );
}